// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"97ab402d","553":"f1fbad44","644":"a1023a1f"}[chunkId] + ".chunk.js";
};